import AboutUs from "../home/about_us";
import MembresExecutifs from "./membres_exec";
import NosCellules from "./nos_cellules";

const About = () => {
  return (
    <div>
      <AboutUs />
      <NosCellules />
      <MembresExecutifs />
    </div>
  );
};

export default About;
